<template>
	<div class="recommendations_panel stream_panel">

		<div class="sec_sep"></div>

    	<div v-if="isRecommendationFeatureEnabled">

      		<div class="sec_hd">
    			<h3 class="ace_sec_hd" :aria-label="streamRecommendationsLabel">{{streamRecommendationsLabel}}</h3>
    			<!--
      			<b-link href="javascript:void(0);" aria-label="more" class="ace_sec_txt" @click="navigateToStreamsView()" :active="active === streams" style="float: right;">more</b-link>
      			-->
    		</div>

			<div v-if="allRecommendations && allRecommendations.length > 0" class="pg_sec">

				<div class="row content_row">
          <div v-if="isAdvisorStreamRecommendationsEnabled" class="row stream_type_sec">
            <div class="col-12" v-if="advisorStreamRecommendations && advisorStreamRecommendations.length > 0">

              <div class="row content_row">
                <div class="col-12 sub_hd ace_sec_hd" :aria-label="advisorStreamRecommendationsLabel">{{advisorStreamRecommendationsLabel}}</div>
              </div>

              <div class="row content_row">
                <div class="col-12">
                  <div class="row">
                    <template v-for="(stream, index) in advisorStreamRecommendationsToShow">
											<div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 content_block">
	                      <div class="content_block_inner">
	                        <!--
	                        <div class="float-left mr-5 pointer">
	                          <span v-if="isProgramCreditProgressEnabled && isStudentLogin" class="title" :id="'advisorStreamCreditProgressPopup_' + stream.uuid" @click="calculateStreamCreditProgressClicked(stream, $event)" style="font-size: 13px; color: #74aac2;">Credits</span>
	                        </div>
	                        -->
	                        <div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.title" :title="stream.title" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
	                          <div class="txt_bx" :id="setTitleBoxWidth(stream.title, 'thumbAdSt_' + index)" v-html="setTitleInitials(stream.title)"></div>
	                        </div>
	                        <div class="title_container" :style="{width: (isProgramCreditProgressEnabled && isStudentLogin) ? 'calc(100% - 135px) !important' : ''}">
	  												<span class="icon icon-stream"></span>
	  												<span class="title_new" tabindex="0" @click="goToStreamTime(stream)" :aria-label="stream.title" :title="stream.title">
	  													<v-clamp class="title_txt" autoresize :max-lines="2">{{ stream.title }}</v-clamp>
	  												</span>
	  												<template v-if="shouldShowBookmarks && isBookmarked(stream)">
	        										<span @click.stop.prevent="deleteStreamBookmark(stream)" class="ace_sec_txt ic_bm_container bookmarked" title="remove this advisor stream from bookmark">
																<span class="icon ic8-bookmark3"></span>
															</span>
	      										</template>
	      										<template v-if="shouldShowBookmarks && !isBookmarked(stream)">
	        										<span @click.stop.prevent="bookmarkStream(stream)" class="ace_sec_txt ic_bm_container" title="bookmark this advisor stream">
																<span class="icon ic8-bookmark3"></span>
															</span>
	      										</template>
	  											</div>
	                      </div>
											</div>
                    </template>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div v-if="isAlumniStreamRecommendationsEnabled" class="row stream_type_sec">
            <div class="col-12" v-if="alumniStreamRecommendations && alumniStreamRecommendations.length > 0">

              <div class="row content_row">
                <div class="col-12 sub_hd ace_sec_txt" :aria-label="alumniStreamRecommendationsLabel">{{alumniStreamRecommendationsLabel}}</div>
              </div>

              <div class="row content_row">
                <div class="col-12">
                  <div class="row">
                    <template v-for="(stream, index) in alumniStreamRecommendationsToShow">
											<div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 content_block">
	                      <div class="content_block_inner">
	                        <!--
	                        <div class="float-left mr-5 pointer">
	                          <span v-if="isProgramCreditProgressEnabled && isStudentLogin" class="title" :id="'alumniStreamCreditProgressPopup_' + stream.uuid" @click="calculateStreamCreditProgressClicked(stream, $event)" style="font-size: 13px; color: #74aac2;">Credits</span>
	                        </div>
	                        -->
	                        <div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.streamTitle" :title="stream.streamTitle" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
	                          <div class="txt_bx" :id="setTitleBoxWidth(stream.title, 'thumbAlSt_' + index)" v-html="setTitleInitials(stream.title)"></div>
	                        </div>
	                        <div class="title_container" :style="{width: (isProgramCreditProgressEnabled && isStudentLogin) ? 'calc(100% - 40px) !important' : ''}">
	  												<span class="icon icon-stream"></span>
	  												<span class="title_new" tabindex="0" @click="goToStreamTime(stream)" :aria-label="stream.title" :title="stream.title">
	  													<v-clamp class="title_txt" autoresize :max-lines="2">{{ stream.title }}</v-clamp>
	  												</span>
	  												<template v-if="shouldShowBookmarks && isBookmarked(stream)">
	        										<span @click.stop.prevent="deleteStreamBookmark(stream)" class="ace_sec_txt ic_bm_container bookmarked" title="remove this alumni stream from bookmark">
																<span class="icon ic8-bookmark3"></span>
															</span>
	      										</template>
	      										<template v-if="shouldShowBookmarks && !isBookmarked(stream)">
	        										<span @click.stop.prevent="bookmarkStream(stream)" class="ace_sec_txt ic_bm_container" title="bookmark this alumni stream">
																<span class="icon ic8-bookmark3"></span>
															</span>
	      										</template>
	  											</div>
	                      </div>
											</div>
                    </template>
                  </div>
                </div>
              </div>

            </div>
          </div>
					<!-- <template v-for="(stream, index) in alumniStreamRecommendationsToShow" class="row content_row">
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 content_block">
							<div class="content_block_inner" @click.stop="goToStreamTime(stream)">

		 						<div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.title" :title="stream.title" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
		  							<div class="txt_bx" :id="setTitleBoxWidth(stream.title, 'thumbAdSt2_' + index)" v-html="setTitleInitials(stream.title)"></div>
		  						</div>
		  						<div class="title_container">
		  							<span class="icon icon-stream"></span>
		  							<span class="title_new" tabindex="0" @click="goToStreamTime(stream)" :aria-label="stream.title" :title="stream.title">
		  								<v-clamp class="title_txt" autoresize :max-lines="2">{{ stream.title }}</v-clamp>
		  							</span>
		  							<template v-if="shouldShowBookmarks && isBookmarked(stream)">
		        					<span @click.stop.prevent="deleteStreamBookmark(stream)" class="ace_sec_txt icon icon-bookmark bookmarked" title="remove this alumni stream from bookmark"></span>
		      					</template>
		      					<template v-if="shouldShowBookmarks && !isBookmarked(stream)">
		        					<span @click.stop.prevent="bookmarkStream(stream)" class="ace_sec_txt icon icon-bookmark"  title="bookmark this alumni stream"></span>
		      					</template>
		  						</div>


								<span v-if="!shouldShowBookmarks" tabindex="0">
								</span>

		     				</div>
	     				</div>
	    			</template> -->
    			</div>

    			<template v-if="showStreamCreditProgressPopup">
                    <program-guide-stream-credit-progress
                        :title="selectedStream.title"
                        :stream-id="selectedStream.uuid"
                        :program-id="programGuide.uuid"
                        :credit-progress-target-id="creditProgressTargetId">
                    </program-guide-stream-credit-progress>
                </template>

    		</div>

    		<div v-else class="msg_no_data empty_pattern ace_sec_txt" aria-label="No stream recommendations found">
      			No {{streamRecommendationsLabel}} recommendations found
    		</div>
    	</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideStreamCreditProgress from './ProgramGuideStreamCreditProgress'
import _ from 'lodash'
import VClamp from 'vue-clamp'

export default {
  name: 'program-guide-recommendations',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBookmarks', 'isStreamsPage'],
  components: {
    ProgramGuideStreamCreditProgress,
    VClamp
  },
  data: () => {
    return {
      userId: localStorage.getItem('userid'),
      RECOMMENDATION_TERM_LIMIT: 5,
      DEFAULT_TYPE: 'MAJOR',
      STREAM_LIMIT: 4,
      selectedStream: null,
      creditProgressTargetId: '',
      showStreamCreditProgressPopup: false
    }
  },
  async mounted () {
    await this.loadAllBookmarks()
    await this.loadDataForProgramGuideRecommendations()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'loadProgramCareerResult',
      'loadAlumniStreamRecommendations',
      'loadAdvisorStreamRecommendations',
      'resetProgramCareerResult',
      'loadAllBookmarks',
      'loadCreateBookmarks',
      'loadDeleteBookmark'
    ]),
    async loadDataForProgramGuideRecommendations () {
      if (this.isRecommendationFeatureEnabled) {
        let programGuide = await this.loadProgramGuide({
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.programGuideType
        })
        let relatedCareers = await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: true })
        let alumniRecommendationData = this.buildAlumniStreamRecommendationData(programGuide, relatedCareers)
        let advisorRecommendationData = this.buildAdvisorStreamRecommendationData(programGuide)
        this.loadAlumniStreamRecommendations({ recommendationData: alumniRecommendationData })
        this.loadAdvisorStreamRecommendations({ recommendationData: advisorRecommendationData })
      }
    },
    goToStreamTime (stream) {
      let routerParams = {
        uuid: stream.uuid,
        cipCode: this.cipCode,
        returnTo: 'programGuideStreams'
      }
      return this.$router.push({ name: 'streamTime', params: routerParams })
    },
    setTitleInitials (entityTitle) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    setTitleBoxWidth (entityTitle, entityId) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      if (getTitleInitials.length < 3) {
        $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
      }
      return entityId
    },
    setThumbnailBgColor (entityId) {
      let getNumricValue = entityId.replace(/[^0-9]/g, '')
      return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
    },
    navigateToStreamsView () {
      return this.$router.push({ name: 'programGuideStreams', params: this.programGuideRouterParams })
    },
    parseTerms (sourceList) {
      if (!sourceList || !sourceList.length) {
        return
      }
      let targetList = []
      let TERM_LIMIT = this.RECOMMENDATION_TERM_LIMIT
      sourceList.forEach((item, i) => {
        if (i < TERM_LIMIT) {
          let curr = JSON.parse(item)
          targetList.push(curr.name)
        }
      })
      return targetList
    },
    buildAlumniStreamRecommendationData (programGuide, careerInfo) {
      let data = {
        'cipCode': programGuide.cipCode,
        'title': programGuide.title,
        'targetOccupations': [],
        'topCompanies': [],
        'topSkills': []
      }

      if (!careerInfo) {
        return data
      }

      // data.targetOccupations = this.parseTerms(careerInfo.targetOccupations)
      // data.topCompanies = this.parseTerms(careerInfo.topPostingCompanies)
      // data.topSkills = this.parseTerms(careerInfo.topSkills)
      return data
    },
    buildAdvisorStreamRecommendationData (programGuide) {
      let data = {
        'requestType': 'programguide',
        'cipCode': programGuide.cipCode
      }
      return data
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    getStreamBookmark (stream) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === stream.uuid) {
          target = bookmark
        }
      })
      return target
    },
    isBookmarked (stream) {
      return stream.bookmark && stream.bookmark.uuid
    },
    async bookmarkStream (stream) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'stream',
        'entityTitle': stream.title,
        'entityUuid': stream.uuid,
        'userId': this.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + stream.title + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Stream as bookmarked
    },
    async deleteStreamBookmark (stream) {
      await this.loadDeleteBookmark(stream.bookmark.uuid)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Stream as bookmarked
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    calculateStreamCreditProgressClicked (stream, event) {
      this.selectedStream = stream
      this.creditProgressTargetId = event.target.id
      this.showStreamCreditProgressPopup = true
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'alumniStreamRecommendations': state => state.stream.alumniStreamRecommendations,
      'advisorStreamRecommendations': state => state.stream.advisorStreamRecommendations,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'bookmarks': state => state.explore.bookmarks
    }),
    streamRecommendationsLabel () {
      const defaultLabel = 'Pathways'
      let streamRecommendationsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID]
      if (!streamRecommendationsFeature || !streamRecommendationsFeature.label) {
        return defaultLabel
      }
      return streamRecommendationsFeature.label || defaultLabel
    },
    alumniStreamRecommendationsToShow () {
      let alumniStreamRecommendations = this.alumniStreamRecommendations
      if (!alumniStreamRecommendations || !alumniStreamRecommendations.length) {
        return []
      }
      if (this.isStreamsPage) {
        alumniStreamRecommendations.forEach(recommendation => {
          recommendation.bookmark = this.shouldShowBookmarks ? this.getStreamBookmark(recommendation) : false
          recommendation.title = recommendation.streamTitle
          recommendation.uuid = recommendation.streamId
        })
        if (alumniStreamRecommendations.length > 4) {
          return alumniStreamRecommendations.splice(0, 4)
        } else {
          return alumniStreamRecommendations
        }
      } else {
        let recommendation = _.cloneDeep(alumniStreamRecommendations[0])
        recommendation.title = recommendation.streamTitle
        recommendation.uuid = recommendation.streamId
        recommendation.bookmark = this.shouldShowBookmarks ? this.getStreamBookmark(recommendation) : false
        return [recommendation]
      }
    },
    alumniStreamRecommendationsLabel () {
      const defaultLabel = 'Alumni Streams'
      let recommendationFlagMap = this.recommendationFlagMap
      if (!recommendationFlagMap || !recommendationFlagMap.showAlumniStreamRecommendations) {
        return defaultLabel
      }
      return recommendationFlagMap.showAlumniStreamRecommendations.label || defaultLabel
    },
    advisorStreamRecommendationsToShow () {
      let advisorStreamRecommendations = this.advisorStreamRecommendations
      if (!advisorStreamRecommendations || !advisorStreamRecommendations.length) {
        return []
      }
      if (this.isStreamsPage) {
        advisorStreamRecommendations.forEach(recommend => {
          recommend.bookmark = this.shouldShowBookmarks ? this.getStreamBookmark(recommend) : false
        })
        if (advisorStreamRecommendations.length > 4) {
          return advisorStreamRecommendations.splice(0, 4)
        } else {
          return advisorStreamRecommendations
        }
      } else {
        let recommendation = _.cloneDeep(advisorStreamRecommendations[0])
        recommendation.bookmark = this.shouldShowBookmarks ? this.getStreamBookmark(recommendation) : false
        return [recommendation]
      }
    },
    advisorStreamRecommendationsLabel () {
      const defaultLabel = 'Advisor Streams'
      let recommendationFlagMap = this.recommendationFlagMap
      if (!recommendationFlagMap || !recommendationFlagMap.showAdvisorStreamRecommendations) {
        return defaultLabel
      }
      return recommendationFlagMap.showAdvisorStreamRecommendations.label || defaultLabel
    },
    allRecommendations () {
      let recommendations = []
      let alumniStreamRecommendations = this.alumniStreamRecommendations
      let advisorStreamRecommendations = this.advisorStreamRecommendations
      if (!alumniStreamRecommendations && !advisorStreamRecommendations) {
        return []
      }
      const STREAM_LIMIT = this.STREAM_LIMIT
      let count = 0
      let isEnabled = this.isAdvisorStreamRecommendationsEnabled === true
      let getBookmark = this.getStreamBookmark
      let shouldShowBookmarks = this.shouldShowBookmarks
      if (isEnabled && advisorStreamRecommendations && advisorStreamRecommendations.length > 0) {
        advisorStreamRecommendations.forEach(advisorRec => {
          if (count < (STREAM_LIMIT / 2)) {
            let recommendation = _.cloneDeep(advisorRec)
            recommendation.bookmark = shouldShowBookmarks ? getBookmark(recommendation) : false
            recommendations.push(recommendation)
            count += 1
          }
        })
      }
      isEnabled = this.isAlumniStreamRecommendationsEnabled === true
      if (isEnabled && alumniStreamRecommendations && alumniStreamRecommendations.length > 0) {
        alumniStreamRecommendations.forEach(alumniRec => {
          if (count < STREAM_LIMIT) {
            let recommendation = _.cloneDeep(alumniRec)
            recommendation.title = recommendation.streamTitle
            recommendation.uuid = recommendation.streamId
            recommendation.bookmark = shouldShowBookmarks ? getBookmark(recommendation) : false
            recommendations.push(recommendation)
            count += 1
          }
        })
      }
      return recommendations
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getExploreSearchPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    shouldShowBookmarks () {
      let showBookmarks = this.showBookmarks
      return showBookmarks === 'true' || showBookmarks === true
    },
    isProgramCreditProgressEnabled () {
      let path = this.$router.currentRoute.fullPath
      let isPathwaysTab = (path.indexOf('streams') !== -1)
      if (isPathwaysTab) {
        return false
      }
      let recommendationFlagMap = this.recommendationFlagMap
      if (!recommendationFlagMap || !recommendationFlagMap.showProgramCreditProgress) {
        return false
      }
      return recommendationFlagMap.showProgramCreditProgress.enabled
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },
  watch: {
  }
}
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideRecommendations.vue